import * as types from '../mutations'
import ConfigService from '@/services/stc-configs'

const state = {
  configs: [],
  loading: true,
  didProductUpdate: false,
  loaded: false
}

const getters = {
  landingPages: (state) => state.configs,
  landingPagesLoaded: (state) => state.loaded,
  loadingLandingPages: (state) => state.loading,
  didProductUpdate: (state) => state.didProductUpdate,
  getLandingPage: (state) => (id) => {
    if (!state.configs) {
      return null
    }
    return state.configs.find((c) => {
      return c.id === id
    })
  }
}

const actions = {

  async searchLandingPages ({ commit }, { search }) {
    const res = await ConfigService.loadConfigs({ search: search })
    return res
  },

  async loadLandingPages ({ commit }) {
    commit(types.SET_LANDING_PAGE_LOADING, true)
    const configs = await ConfigService.loadConfigs()
    commit(types.SET_LANDING_PAGE_LOADING, false)
    commit(types.SET_LANDING_PAGE_LOADED, true)
    commit(types.SET_LANDING_PAGE_LIST, configs)
  },

  async loadLandingPage ({ commit }, { id }) {
    const config = await ConfigService.loadConfig(id)
    if (config) {
      return config
    }
  },

  async createLandingPage ({ commit }, { name, configJson }) {
    const config = await ConfigService.createConfig(name, configJson)
    return config.id
  },

  async updateLandingPage ({ commit }, { id, configJson }) {
    const config = await ConfigService.updateConfig(id, configJson)
    return config
  }

}

const mutations = {
  [types.SET_LANDING_PAGE_LIST] (state, configs) {
    state.configs = configs
  },

  [types.SET_LANDING_PAGE_LOADED] (state, loaded) {
    state.loaded = loaded
  },

  [types.SET_LANDING_PAGE_LOADING] (state, loading) {
    state.loading = loading
  },

  [types.UPDATE_PRODUCT_UPDATE_STATUS] (state, status) {
    state.didProductUpdate = status
  }

}

export default {
  state,
  getters,
  actions,
  mutations
}
